<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="ViewRecord" />
    <feather-icon v-if="!this.params.data.islocked && !loginRole.includes('accountant')" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
  </div>
</template>

<script>
export default {
name: 'CellRendererActions',
data() {
  return {
    loginRole: '' // Initialisation de la variable loginRole
  }
},
mounted() {
  // On récupère les rôles depuis localStorage dans le lifecycle hook
  const role = localStorage.getItem('login-roles');
  if (role) {
    this.loginRole = role.toLowerCase(); // Assigne la valeur convertie en minuscule
  }
},
methods: {
  editRecord () {
      this.$router.push("/invoice-edit/" + this.params.data.id).catch(() => {})
  },
  ViewRecord () {
      const id = this.params.data.id;
      const hasQuotation = (this.params.data.idquotation_invoice != null && this.params.data.idquotation_invoice !== undefined) ||
        (this.params.data.quotation_no != null && this.params.data.quotation_no !== '');
      const path = hasQuotation ? "/invoice/" + id : "/firewood-invoice/" + id;
      this.$router.push(path).catch(() => {})
  }
}
//!localStorage.getItem('login-roles').toLowerCase().includes('accountant')
}
</script>

